var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sections"},_vm._l((_vm.sections),function(section){return _c('vSection',_vm._b({key:section.id},'vSection',{section: section},false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }